import ActivitySwitch from "@/components/Common/ActivitySwitch/ActivitySwitch.vue";
import "./EventsOverview.scss";

export default {
  name: "EventsOverview",
  components: { ActivitySwitch },
  data: () => ({
    ignoreUser: false,
    config: {},
    options: {
      legend: {
        display: true
      },
      responsive: true,
      maintainAspectRatio: false
    }
  }),
  async mounted() {
    try {
      await this.$store.dispatch("getEventStatistics");
      await this.$store.dispatch("getAllUsers");
    } catch (error) {
      await this.$store.dispatch("createError", error);
    }
  },
  methods: {
    loadStatistics() {
      return this.$store.dispatch("getEventStatistics", {
        ignoreUser: this.ignoreUser ? 1 : 0
      });
    },
    goTo(path) {
      this.$router.push(path);
    },
    getUserAvatar(updatedBy) {
      let user = this.users?.find(user => user._id === updatedBy);
      if (!user && this.user?._id === updatedBy) {
        user = this.user;
      }
      return user?.avatar_uri || "";
    }
  },

  computed: {
    statistics() {
      return this.$store.state.eventStatistics;
    },
    lastActivities() {
      return this.$store.state.eventStatistics?.last_events ?? [];
    },
    user() {
      return this.$store.state.currentUser;
    },
    users() {
      return this.$store.state.users ?? [];
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
    isAdmin() {
      return this.currentUser?.scopes?.includes("role:admin");
    },
    isEventAdmin() {
      return (
        this.isAdmin || this.currentUser?.scopes?.includes("role:events_admin")
      );
    },
    isExternEventEditor() {
      return this.currentUser?.scopes?.includes("role:extern_events_editor");
    },
    isEventEditor() {
      return this.currentUser?.scopes?.includes("role:events_editor");
    },
    showOplocs() {
      return (
        this.isAdmin ||
        this.isEventAdmin ||
        this.currentUser?.scopes?.includes("role:events_oploc") ||
        this.currentUser?.scopes?.includes("role:events_editor")
      );
    }
  }
};
